(function () {
  function digitsOnly(value) {
    return (value || '').replace(/\D/g, '').slice(0, 10);
  }

  function formatUSPhone(digits) {
    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  function countDigitsBeforeCursor(value, cursorIndex) {
    return value.slice(0, cursorIndex).replace(/\D/g, '').length;
  }

  function cursorIndexAfterNthDigit(formattedValue, nth) {
    if (nth <= 0) return 0;
    let seen = 0;
    for (let i = 0; i < formattedValue.length; i++) {
      if (/\d/.test(formattedValue[i])) seen++;
      if (seen === nth) return i + 1;
    }
    return formattedValue.length;
  }

  function applyToInput(input) {
    if (input.dataset.telFormatApplied === 'true') return;
    input.dataset.telFormatApplied = 'true';

    // Helpful UX defaults (won't override if already set in markup)
    if (!input.getAttribute('inputmode')) input.setAttribute('inputmode', 'numeric');
    if (!input.getAttribute('autocomplete')) input.setAttribute('autocomplete', 'tel');
    if (!input.getAttribute('maxlength')) input.setAttribute('maxlength', '14'); // (123) 456-7890

    function reformat(preserveCursor) {
      const oldValue = input.value || '';
      const oldCursor = input.selectionStart ?? oldValue.length;
      const digitIndex = preserveCursor ? countDigitsBeforeCursor(oldValue, oldCursor) : null;

      const digits = digitsOnly(oldValue);
      const nextValue = formatUSPhone(digits);

      input.value = nextValue;

      if (preserveCursor && input === document.activeElement) {
        const nextCursor = cursorIndexAfterNthDigit(nextValue, digitIndex);
        try {
          input.setSelectionRange(nextCursor, nextCursor);
        } catch (_) {
          // ignore (some inputs/browsers can throw)
        }
      }
    }

    input.addEventListener('input', () => reformat(true));

    input.addEventListener('paste', (e) => {
      const text = (e.clipboardData || window.clipboardData)?.getData('text') || '';
      const digits = digitsOnly(text);
      if (!digits) return; // allow normal paste if nothing useful
      e.preventDefault();
      input.value = formatUSPhone(digits);
    });

    // Initial normalization (e.g., prefilled values)
    reformat(false);
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('input[type="tel"]').forEach(applyToInput);
  }

  // Run now + observe for dynamically-added tel inputs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.('input[type="tel"]')) applyToInput(node);
        node.querySelectorAll?.('input[type="tel"]').forEach(applyToInput);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
